import { render, staticRenderFns } from "./FieldSelect.vue?vue&type=template&id=3b5c215c&scoped=true"
import script from "./FieldSelect.vue?vue&type=script&lang=js"
export * from "./FieldSelect.vue?vue&type=script&lang=js"
import style0 from "./FieldSelect.vue?vue&type=style&index=0&id=3b5c215c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5c215c",
  null
  
)

export default component.exports